import { AppState } from 'store';
import { ReducerNames } from 'common';
import { RecentReportsResult } from './models';

const { RECENT_REPORTS } = ReducerNames;

export const recentReportsSelector = ({
  [RECENT_REPORTS]: { recentReports },
}: AppState): RecentReportsResult => recentReports;
